export default "__VITE_ASSET__BmyONo4N__"